import image1 from "../assets/images/partners/V Balasubramanium.webp";
import image2 from "../assets/images/partners/Mahua Ray Bose.webp";
import image3 from "../assets/images/partners/Barenyo Chowdhury.webp";
import image4 from "../assets/images/partners/Sagupta Ghosh.webp";
import image5 from "../assets/images/partners/Sanjeev Chowdhury.webp";
import image6 from "../assets/images/partners/Abhishek Anand.webp";
import image7 from "../assets/images/partners/Pronab Mondol.webp";
import image8 from "../assets/images/partners/Md. Ismile Hossain.webp";
import image9 from "../assets/images/partners/Monjur Rashid.webp";
import image10 from "../assets/images/partners/Geetha Punj.webp";
import image11 from "../assets/images/partners/Aparimita Mitra.webp";
import image12 from "../assets/images/partners/Suchita Dutta.webp";

export const partners = [
  {
    id: 1,
    name: "V Balasubramanium",
    image: image1,
    designation: "Co-Founder And Managing Director",
    companyName: "Rainman",
    companyUrl: "www.therainman.in",
    linkedinUrl:
      "https://www.linkedin.com/in/balasubramanium-venkitachalam-3963552",
  },
  {
    id: 2,
    name: "Mahua Ray Bose",
    image: image2,
    designation: "Chief Statistician",
    companyName: "Radix Analytics",
    companyUrl: "www.radixanalytics.com",
    linkedinUrl: "https://www.linkedin.com/in/mahua-bose-4a511729/",
  },
  {
    id: 3,
    name: "Barenyo Chowdhury",
    image: image3,
    designation: "Founder and CEO",
    companyName: "IKOnet",
    companyUrl: "www.ikonet.in",
    linkedinUrl: "https://www.linkedin.com/in/barenyo-chowdhury-92b03312/",
  },
  {
    id: 4,
    name: "Sagupta Ghosh",
    image: image4,
    designation: "Client Lead & Modeling Expert",
    companyName: "IKOnet",
    companyUrl: "www.ikonet.in",
    linkedinUrl: "https://www.linkedin.com/in/sagupta-ghosh-593691231/",
  },
  {
    id: 5,
    name: "Sanjeev Chowdhury",
    image: image5,
    designation: "Industry Leader - Operations & Technology",
    companyName: "",
    companyUrl: "",
    linkedinUrl: "https://www.linkedin.com/in/sanjeev-chowdhury-24574321a/",
  },
  {
    id: 6,
    name: "Abhishek Anand",
    image: image6,
    designation: "Senior Manager",
    companyName: "Meltwater",
    companyUrl: "www.meltwater.com/en",
    linkedinUrl: "https://www.linkedin.com/in/anand-abhishek/",
  },
  {
    id: 7,
    name: "Pronab Mondol",
    image: image7,
    designation: "Managing Director & CEO",
    companyName: "DBI Research",
    companyUrl: "www.dbibd.com/",
    linkedinUrl: "https://www.linkedin.com/in/pronab-mondol-55b3592b/",
  },
  {
    id: 8,
    name: "Md. Ismile Hossain",
    image: image8,
    designation: "Director, Analytics & Automation",
    companyName: "DBI Research",
    companyUrl: "www.innovatehub.io",
    linkedinUrl: "https://www.linkedin.com/in/md-ismile-hossain-4aa5b856/",
  },
  {
    id: 9,
    name: "Monjur Rashid",
    image: image9,
    designation: "Project Management Expert",
    companyName: "",
    companyUrl: "",
    linkedinUrl: "https://www.linkedin.com/in/monjurrashed/",
  },
  {
    id: 10,
    name: "Geetha Punj",
    image: image10,
    designation: "Consumer Insights & Market Research Professional",
    companyName: "",
    companyUrl: "",
    linkedinUrl: "https://www.linkedin.com/in/geethapunj/",
  },
  {
    id: 11,
    name: "Aparimita",
    image: image11,
    designation:
      "Senior Ethnographer, Qualitative Researcher and Brand Strategist",
    companyName: "",
    companyUrl: "",
    linkedinUrl: "https://www.linkedin.com/in/aparimita-mitra-0045584/",
  },
  {
    id: 12,
    name: "Suchita Dutta",
    image: image12,
    designation: "Qualitative Market Research Consultant",
    companyName: "",
    companyUrl: "",
    linkedinUrl: "https://www.linkedin.com/in/suchita-dutta-438036b/",
  },
];
